<template>
  <div class="mt-40">
    <p class="has-text-grid-1 is-size-14px has-text-weight-bold pb-20">
      {{ $t('creerPanneau.titlePropFinanciere') }}
    </p>

    <AppBudget
      v-model="openGenerateCollapse"
      :budget="panneau.budgetGeneration"
      :title="$t('creerPanneau.titleGenererProposition')"
      :is-generation="true"
      :error="error.budgetGeneration"
      :panneau="panneau"
      :regies="regies"
      @genererBudgets="handlerGenererBudgets"/>

    <div
      v-for="budget in panneau.budgets"
      :key="budget.guid"
      class="mt-20">
      <AppBudget
        :value="true"
        :budget="budget"
        :title="getTitleBloc(budget)"
        :error="error.budgets[budget.guid]"
        :panneau="panneau"
        :regies="regies"
        @supprimer="handlerSupprimerBloc(budget.guid)"/>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import AppBudget from '@/components/recommandation/creerPanneau/budget.vue';
import { genererBudgetsPanneau } from '@/services/gestionPanneau/genererBudgetsPanneau';
import { genererObjectErrorBudgets } from '@/services/gestionPanneau/validationPanneau';
import { controleBudget } from '@/services/gestionPanneau/validationPanneau';

const Recommandations = createNamespacedHelpers('recommandations');

export default {
  name: 'PropositionFinanciere',
  props: {
    error: {
      type: Object,
      default: () => ({}),
    },
    panneau: {
      type: Object,
      required: true,
    },
    regies: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    AppBudget,
  },
  data() {
    return {
      openGenerateCollapse: true,
    };
  },
  computed: {
    ...Recommandations.mapGetters({
      pointDeVente: 'pointDeVente',
    }),
  },
  methods: {
    getTitleBloc(budget) {
      const debut = moment(budget.dateDebut).format('DD/MM/YYYY');
      const fin = moment(budget.dateFin).format('DD/MM/YYYY');
      return this.$t('creerPanneau.titreBlocBudget', { debut, fin });
    },
    handlerGenererBudgets() {
      controleBudget(this.panneau.budgetGeneration, this.error.budgetGeneration, true);
      const hasErrorBudgetGeneration = Object.values(this.error.budgetGeneration).some(Boolean);
      if (hasErrorBudgetGeneration) return;
      this.panneau.budgets = genererBudgetsPanneau(this.panneau.budgetGeneration, this.pointDeVente);
      this.error.budgets = genererObjectErrorBudgets(this.panneau.budgets);
      this.openGenerateCollapse = false;
    },
    handlerSupprimerBloc(guid) {
      this.panneau.budgets = this.panneau.budgets.filter(b => b.guid !== guid);
    },
  },
  mounted() {
    this.openGenerateCollapse = !this.panneau.budgets.length;
  },
};
</script>
